import type { CategoryListItem } from '@/types/apis/Category';
import type { IErrorResponse } from '@/types/apis/Error';
import type { PaginationResponse } from '@/types/PaginationResponse';

import { useQuery, type UseQueryResult } from '@tanstack/react-query';

import url from '@/statics/urls';

const useLessonCategories = (): UseQueryResult<
  CategoryListItem[],
  IErrorResponse
> => {
  return useQuery({
    queryKey: [`${url.categories}?type=education_content`],
    select: (result: PaginationResponse<CategoryListItem>) => result.list,
  });
};
export default useLessonCategories;
